var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[(_vm.hasData)?_c('v-alert',{attrs:{"value":true,"type":"warning","dismissible":""}},[_c('p',[_vm._v(_vm._s(this.$config.messages.Common.Warn.CapitalBlankDeliveryCompany))]),_vm._l((_vm.capitalBlankList),function(rec){return _c('div',[_vm._v(_vm._s(rec.companyName))])})],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }